import PropTypes from 'prop-types';
import React from 'react';

import Popup from "reactjs-popup";
import CurrencyInput from '../../CurrencyInput/components/CurrencyInput';

import NewRefund from "./Refund/NewRefund";
import ReviewRefund from "./Refund/ReviewRefund";

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const modalContentStyle = {
  "backgroundColor": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "840px",
  "padding": "0px"
}

const RefundModal = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  refund,
  fetchNewRefund,
  refundChanged,
  refundReasons,
  createRefund,
  submittingRefund,
  confirmRefund,
  venueOwedBalance,
  canBypassRefundRestrictions
}) => (
  <div>
    <Popup
      open={(Object.keys(refund).length > 0)}
      contentStyle={modalContentStyle}
      closeOnDocumentClick={false}
      className={"popup-modal"}
      onClose={() => refundChanged({})}
    >
      {/* refund-modal scopes the .text-danger override in theme.css to this one modal.
          .popup-modal-container alone appears in 49 files. */}
      <div className="popup-modal-container refund-modal">
        {refund && refund.id ? (
          <ReviewRefund csrfToken={csrfToken}
                        team={team}
                        currentUser={currentUser}
                        confirm={confirm}
                        refund={refund}
                        refundChanged={refundChanged}
                        submittingRefund={submittingRefund}
                        confirmRefund={confirmRefund} />
        ) : (
          <NewRefund csrfToken={csrfToken}
                     team={team}
                     currentUser={currentUser}
                     confirm={confirm}
                     refund={refund}
                     refundChanged={refundChanged}
                     refundReasons={refundReasons}
                     createRefund={createRefund}
                     submittingRefund={submittingRefund}
                     venueOwedBalance={venueOwedBalance}
                     canBypassRefundRestrictions={canBypassRefundRestrictions} />
        )}
      </div>
    </Popup>
  </div>
);

RefundModal.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  refund: PropTypes.object,
  fetchNewRefund: PropTypes.func.isRequired,
  refundChanged: PropTypes.func.isRequired,
  refundReasons: PropTypes.array,
  createRefund: PropTypes.func.isRequired,
  submittingRefund: PropTypes.bool,
  confirmRefund: PropTypes.func.isRequired,
  venueOwedBalance: PropTypes.number,
  canBypassRefundRestrictions: PropTypes.bool
};

export default RefundModal;
